export enum NewsRcExternalFilterType {
  All = 'All',
  RCOnly = 'RC Only',
  ExternalNewsOnly = 'External News Only',
}
